import { Store } from 'redux';
import { RequestHandler } from 'apollo-link';
import { getAuthorizationHeader } from 'store/authentication/selectors';
import { createTrackingHeaders } from './createTrackingHeaders';
import { setTags as setSentryTags } from '@sentry/browser';

export const setRequestHeaders = (store: Store): RequestHandler => (operation, forward) => {
  const trackingHeaders = createTrackingHeaders();

  setSentryTags(trackingHeaders);

  operation.setContext({
    headers: {
      ...trackingHeaders,
      authorization: getAuthorizationHeader(store.getState()),
    },
  });

  return forward(operation);
};
